(function () {
  if (window.RecentlyViewedProducts) return;

  var STORAGE_KEY = 'xt:recently-viewed-products';
  var MAX_ITEMS = 12;

  function readHandles() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ITEMS)));
    } catch (error) {
      /* localStorage unavailable (private mode, storage full, etc.) */
    }
  }

  function recordProductView(handle) {
    if (!handle) return;
    var handles = readHandles().filter(function (existing) {
      return existing !== handle;
    });
    handles.unshift(handle);
    writeHandles(handles);
  }

  window.RecentlyViewedProducts = {
    recordProductView: recordProductView,
    readHandles: readHandles,
  };

  class RecentlyViewedProductsSection extends HTMLElement {
    connectedCallback() {
      var limit = parseInt(this.dataset.limit, 10) || 12;
      var excludeHandle = this.dataset.productHandle || '';

      var handles = readHandles()
        .filter(function (handle) {
          return handle !== excludeHandle;
        })
        .slice(0, limit);

      if (!handles.length) return;

      this.loadProducts(handles);
    }

    loadProducts(handles) {
      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + handle + '?section_id=recently-viewed-product-card')
            .then(function (response) {
              return response.ok ? response.text() : null;
            })
            .then(function (text) {
              if (!text) return null;
              var html = new DOMParser().parseFromString(text, 'text/html');
              var card = html.querySelector('.row-products__item');
              return card ? card.outerHTML : null;
            })
            .catch(function () {
              return null;
            });
        })
      ).then((cards) => {
        var found = cards.filter(Boolean);
        if (found.length) this.render(found);
      });
    }

    render(cards) {
      var list = this.querySelector('[data-row-products-list]');
      if (!list) return;

      list.innerHTML = cards.join('');
      this.hidden = false;

      var scrollbar = this.querySelector('row-products-scrollbar');
      if (scrollbar && typeof scrollbar.update === 'function') scrollbar.update();
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProductsSection);
  }
})();
